import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-56437806"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "mySet"
};
const _hoisted_2 = {
  class: "user-set-list"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "user-set-item"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "user-set-key"
}, "当前版本"), /*#__PURE__*/_createElementVNode("div", {
  class: "user-set-value"
}, "v1.2.0")], -1));

const _hoisted_4 = {
  class: "user-set-item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "btn",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.logout && $setup.logout(...args))
  }, "退出")])])]);
}